import React from 'react';
import PdfHeaderComponent from './PdfHeaderComponent';
import DashboardListCard from '../../../../ui/DashboardListCard';
import DashboardMetricCard from '../../../../ui/DashboardMetricCard';
import Loader from '../../../../ui/Loader';
import {
    ParticipantsIcon,
    ActivitiesIcon,
    FundsIcon,
    ImpactCertificatesIcon,
    SurveyIcon,
    ScoutingIcon,
    HarvestIcon,
    VolunteerIcon,
    UserAvatarIcon
} from '../../../../assets/icons/DashboardIcons';
import { bountyTypesWithIconDataRef } from '../../../../constants/datas';

const OverallTabPageComponent = ({ overallData, projectData, loading = false }) => {
  // Prepare the data structure similar to OverallTab
  const overallTabData = {
    metrics: [
      { title: 'Participants till date', value: overallData?.uniqueBountyAcceptorCount, icon: ParticipantsIcon },
      { title: 'Activities completed', value: overallData?.completedBountyCount, icon: ActivitiesIcon },
      { title: 'Funds Deployed', value: `$${overallData?.totalFundsDeployedUSD}`, icon: "" },
      { title: 'Impact Certificates Issued', value: overallData?.totalImpactCertificatesIssued, icon: ImpactCertificatesIcon }
    ],
    topActivitiesWithFunds: overallData?.mostRewardingBounties?.map(activity => ({
      title: activity.title,
      value: `$${activity.rewardedAmountUSD}`,
      key: activity._id
    })),
    topActivitiesWithEngagement: overallData?.mostAcceptedBounties?.map(bounty => ({
      title: bounty?.title,
      value: `${bounty?.uniqueAcceptorCount}`,
      key: bounty?._id
    })),
    topActivityTypes: overallData?.mostUsedBountyTypes?.map(activityType => {
      const Icon = bountyTypesWithIconDataRef?.find(type => type.label === activityType?.type)?.icon;
      return {
        title: activityType?.type,
        value: activityType?.bountyCount,
        icon: Icon ? <Icon className="w-5 h-5" fillColor="#23522A" /> : null
      };
    }),
    topParticipants: overallData?.mostActiveUsers?.map(user => ({
      key: user?.uid,
      title: user?.username || "Unknown User",
      subtitle: `${user?.bountyCompletionCount || 0} bounties`,
      value: `${user?.totalImpactPoints || 0} IP`,
      icon: <UserAvatarIcon className="w-5 h-5 text-gray-400" />
    }))
  };

  return (
    <div className="pdf-section pdf-page-break" style={{ display: 'flex', flexDirection: 'column', padding: '20px', height: '100vh' }}>
      <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
      
      <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <h2 className="text-lg font-bold text-gray-900 mb-4">Overview</h2>
        
        {loading ? (
          <div className='w-full h-[39.6875rem] flex pt-11 justify-center'>
            <Loader/>
          </div>
        ) : (
          <div className="space-y-4">
            <style>{`
              .pdf-no-truncate .truncate {
                white-space: normal !important;
                overflow: visible !important;
                text-overflow: unset !important;
              }
            `}</style>
            
            {/* Top Row - Metric Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {overallTabData.metrics.map((metric, index) => (
                <DashboardMetricCard
                  key={index}
                  title={metric.title}
                  value={metric.value}
                  icon={metric.icon}
                  valueClassName='flex items-center gap-2'
                />
              ))}
            </div>

            {/* Middle Row - Top Activities Lists */}
            <div className="grid min-h-[15.2rem] grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-3 pdf-no-truncate">
              <DashboardListCard
                titles={["Top 5 Activities with most funds deployed"]}
                items={overallTabData.topActivitiesWithFunds}
                columnCount={2}
              />
              <DashboardListCard
                titles={["Top 5 Activities with most engagement","Participants"]}
                items={overallTabData.topActivitiesWithEngagement}
                columnCount={2}
              />
            </div>

            {/* Bottom Row - Top Types and Participants Lists */}
            <div className="grid min-h-[15.2rem] grid-cols-1 lg:grid-cols-2 gap-y-4 gap-x-3 pdf-no-truncate">
              <DashboardListCard
                titles={["Top 5 Activity Types", "No. of Activities"]}
                items={overallTabData.topActivityTypes}
                columnCount={2}
              />
              <DashboardListCard
                titles={["Top 5 participants"]}
                items={overallTabData.topParticipants}
                columnCount={3}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OverallTabPageComponent;
